<template>
  <a-upload
    name="file"
    :file-list="fileList"
    :accept="accept"
    :action="action"
    :headers="headers"
    :show-file-list="isShowList"
    :show-upload-list="isShowList"
    @change="handleChange"
    :remove="uploadRemove"
  >
    <slot>
      <a-button> <a-icon type="upload" /> {{ text }} </a-button>
    </slot>
  </a-upload>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    text: {
      type: String,
      default: "上传文件",
    },
    fileTypeCode: {
      type: String,
      required: true,
    },
    isShowList: {
      type: Boolean,
      default: false,
    },
    maxNum: {
      type: Number,
      default: 1,
    },
    accept: String,
  },
  computed: {
    ...mapGetters(["access_token"]),
    action() {
      return `${process.env.VUE_APP_API_PORTAL_URL}/file/upload/${this.fileTypeCode}`;
    },
    headers() {
      const { access_token } = this;
      if (!access_token) {
        return {};
      }
      return { Authorization: `Bearer ${access_token}` };
    },
  },
  data() {
    return {
      fileList: [],
    };
  },
  methods: {
    uploadRemove(info) {
      console.log(info, "-------rem");
      this.$emit("uploadRemove", info.response.data.id);
    },
    emptyList() {
      this.fileList = [];
    },
    handleChange(info) {
      if (this.maxNum > 1 && this.maxNum === this.fileList.length) {
        this.$message.warning(`最多只能上传${info.file.maxNum}个附件`);
        return;
      }
      if (info.file.status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (info.file.status === "done") {
        // console.log(info.file.response.data)
        this.$emit("success", info.file.response.data);
      } else if (info.file.status === "error") {
        this.$message.error(`${info.file.name} file upload failed.`);
      }
      this.fileList = info.fileList;
    },
  },
};
</script>
